// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon[data-v-c8a70580] {\n  width: 1.2em;\n  height: 1.2em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.svg-external-icon[data-v-c8a70580] {\n  background-color: currentColor;\n  mask-size: cover !important;\n  display: inline-block;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
